import { useQuery } from '@tanstack/react-query';
import { accountsQueries } from '../utils/queries';
import { fetchAccounts } from '../api/accounts';
import { isEmpty } from 'lodash';

export const useAccountsByIds = (ids: string[]) => {
  const { data, isFetched, isPending } = useQuery({
    queryKey: accountsQueries.list({ ids }),
    queryFn: () => {
      if (isEmpty(ids)) {
        return [];
      }
      return fetchAccounts({ ids });
    },
    initialData: [],
    enabled: !isEmpty(ids),
  });

  return { selectedAccounts: data, isFetched: isFetched || isEmpty(ids), isPending };
};
